import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SingleColumn from './icon-single-column.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SingleColumn {...validProps} />;
}
SvgComponent.iconName = 'single-column';

export const SingleColumnIcon = svgIconWrapper(SvgComponent);
